// ===========================================
// DonutChart — Répartition (Recharts PieChart en donut)
// ===========================================
import React from 'react';
import { Card, Empty, Skeleton } from 'antd';
import { PieChartOutlined } from '@ant-design/icons';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { formatMontant } from '../../../common/utils/format';

// Palette cohérente avec le branding CAP
const COLORS = ['#1A2B5F', '#C8102E', '#16a34a', '#ea580c', '#7c3aed', '#0891b2', '#d97706', '#64748b'];

const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    const item = payload[0];
    const value = item.value;
    const name = item.payload.nom || item.name;
    return (
        <div className="trend-tooltip">
            <div className="trend-tooltip-label">{name}</div>
            <div className="trend-tooltip-value">
                {item.payload.totalPrimeTTC !== undefined
                    ? `${formatMontant(item.payload.totalPrimeTTC)} F`
                    : value}
                {' · '}
                <span style={{ color: 'var(--cap-text-muted)' }}>{value} contrat{value > 1 ? 's' : ''}</span>
            </div>
        </div>
    );
};

const DonutChart = ({ data, loading, title = 'Répartition par type', subtitle }) => {
    const total = (data || []).reduce((acc, item) => acc + (item.count || 0), 0);

    return (
        <Card
            className="dashboard-chart-card"
            title={
                <div className="chart-card-title">
                    <PieChartOutlined />
                    <span>{title}</span>
                </div>
            }
            extra={subtitle && <span className="chart-card-subtitle">{subtitle}</span>}
        >
            {loading ? (
                <Skeleton active paragraph={{ rows: 6 }} />
            ) : !data || data.length === 0 || total === 0 ? (
                <Empty description="Aucune donnée" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            ) : (
                <div className="donut-chart-wrapper">
                    <div className="donut-chart-pie">
                        <ResponsiveContainer width="100%" height={240}>
                            <PieChart>
                                <Pie
                                    data={data}
                                    dataKey="count"
                                    nameKey="nom"
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={60}
                                    outerRadius={90}
                                    paddingAngle={2}
                                    stroke="var(--cap-surface)"
                                    strokeWidth={2}
                                >
                                    {data.map((entry, idx) => (
                                        <Cell key={entry._id || idx} fill={COLORS[idx % COLORS.length]} />
                                    ))}
                                </Pie>
                                <Tooltip content={<CustomTooltip />} />
                            </PieChart>
                        </ResponsiveContainer>
                        <div className="donut-center">
                            <div className="donut-center-value">{total}</div>
                            <div className="donut-center-label">contrats</div>
                        </div>
                    </div>
                    <ul className="donut-legend">
                        {data.slice(0, 6).map((item, idx) => {
                            const pct = total > 0 ? Math.round((item.count / total) * 100) : 0;
                            return (
                                <li key={item._id || idx} className="donut-legend-item">
                                    <span className="donut-legend-dot" style={{ background: COLORS[idx % COLORS.length] }} />
                                    <span className="donut-legend-name">{item.nom}</span>
                                    <span className="donut-legend-value">{pct}%</span>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </Card>
    );
};

export default DonutChart;
